module.exports = __webpack_public_path__ + "ath_game_web/img/8.6.7330e0a4.png";